module.exports = "<report-component [title]=\"'ALL_SUPPLY' | dictionary\" [injectedDimensions]=\"[1]\" [reportLink]=\"'supply/all'\"></report-component>\n"